export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_45-64d2e8a49ea453ce4bcc893083a6994e.jpg";